// src/components/DeleteConfirmationModal.js
import React, { memo } from "react";
import PropTypes from "prop-types";
import { Modal,  ModalBody } from "reactstrap";
import "../../styles/ModalShared.css";
const BlockUserConfirmationModalComponent = ({
  isOpen,
  toggle,
  onBlock,
  title,
  message,
}) => ( 
  <Modal isOpen={isOpen} toggle={toggle} centered className="custom-modal">
    <ModalBody className="text-center">
      <h5 className="modal-title mb-2">{title}</h5>
      <p className="modal-message mb-0">{message}</p>
    </ModalBody>
    <div className="custom-footer">
      <button className="modal-btn cancel-btn" onClick={toggle}>
        Cancel
      </button>
      <div className="divider" />
      <button className="modal-btn delete-btn" onClick={onBlock}>
        Block
      </button>
    </div>
  </Modal>
);

BlockUserConfirmationModalComponent.displayName = "BlockUserConfirmationModal";

const BlockUserConfirmationModal = memo(BlockUserConfirmationModalComponent);

BlockUserConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  onBlock: PropTypes.func.isRequired,
  userName: PropTypes.string,
};

export default BlockUserConfirmationModal;
